"use client";

import HeroSection from "app/new-home/new-home-page/src/home/HeroSection";
import ValuePropositionSection from "app/new-home/new-home-page/src/home/ValuePropositionSection";
import { PropertyDataV2 } from "commonModule/services/common";
import BookWithConfidenceSection from "components/travel-agent/BookWithConfidenceSection";
import DestinationCard from "components/travel-agent/DestinationCard";
import DestinationRow from "components/travel-agent/DestinationRow";
import FeaturedPropertiesRow from "components/travel-agent/FeaturedPropertiesRow";
import ReadyToGetStartedSection from "components/travel-agent/ReadyToGetStartedSection";
import WhiteGloveSupportSection from "components/travel-agent/WhiteGloveSupportSection";
import { destinationRows } from "config/homePageConfig";
const HomeWrapper = ({
  featuredProperties
}: {
  featuredProperties: PropertyDataV2[];
}) => {
  return <>
      <HeroSection data-sentry-element="HeroSection" data-sentry-source-file="HomeWrapper.tsx" />

      <ValuePropositionSection data-sentry-element="ValuePropositionSection" data-sentry-source-file="HomeWrapper.tsx" />

      <FeaturedPropertiesRow initialData={featuredProperties} data-sentry-element="FeaturedPropertiesRow" data-sentry-source-file="HomeWrapper.tsx" />

      <BookWithConfidenceSection data-sentry-element="BookWithConfidenceSection" data-sentry-source-file="HomeWrapper.tsx" />

      {/* Row 2 - Urban & City */}
      <DestinationRow title={destinationRows[0].title} subtitle={destinationRows[0].subtitle} data-sentry-element="DestinationRow" data-sentry-source-file="HomeWrapper.tsx">
        {destinationRows[0].destinations.map((d, i) => <DestinationCard key={d.path} destination={d} isLazy={i > 2} />)}
      </DestinationRow>

      {/* Row 3 - Nature & Mountains */}
      <DestinationRow title={destinationRows[1].title} subtitle={destinationRows[1].subtitle} data-sentry-element="DestinationRow" data-sentry-source-file="HomeWrapper.tsx">
        {destinationRows[1].destinations.map((d, i) => <DestinationCard key={d.path} destination={d} isLazy={i > 2} />)}
      </DestinationRow>

      <WhiteGloveSupportSection data-sentry-element="WhiteGloveSupportSection" data-sentry-source-file="HomeWrapper.tsx" />

      {/* Row 4 - California Collection */}
      <DestinationRow title={destinationRows[2].title} subtitle={destinationRows[2].subtitle} data-sentry-element="DestinationRow" data-sentry-source-file="HomeWrapper.tsx">
        {destinationRows[2].destinations.map((d, i) => <DestinationCard key={d.path} destination={d} isLazy={i > 2} />)}
      </DestinationRow>

      {/* Row 5 - Florida & Disney */}
      <DestinationRow title={destinationRows[3].title} subtitle={destinationRows[3].subtitle} data-sentry-element="DestinationRow" data-sentry-source-file="HomeWrapper.tsx">
        {destinationRows[3].destinations.map((d, i) => <DestinationCard key={d.path} destination={d} isLazy={i > 2} />)}
      </DestinationRow>

      <ReadyToGetStartedSection data-sentry-element="ReadyToGetStartedSection" data-sentry-source-file="HomeWrapper.tsx" />

      {/* Row 6 - European Charms */}
      <DestinationRow title={destinationRows[4].title} subtitle={destinationRows[4].subtitle} data-sentry-element="DestinationRow" data-sentry-source-file="HomeWrapper.tsx">
        {destinationRows[4].destinations.map((d, i) => <DestinationCard key={d.path} destination={d} isLazy={i > 2} />)}
      </DestinationRow>

      {/* Row 7 - Beach & Coastal */}
      <DestinationRow title={destinationRows[5].title} subtitle={destinationRows[5].subtitle} data-sentry-element="DestinationRow" data-sentry-source-file="HomeWrapper.tsx">
        {destinationRows[5].destinations.map((d, i) => <DestinationCard key={d.path} destination={d} isLazy={i > 2} />)}
      </DestinationRow>
    </>;
};
export default HomeWrapper;